import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class ChatEscalationPaths {
  static chatEscalation = new EnhancedPath('/chat-escalation');
}

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: ChatEscalationPaths.chatEscalation.path,
      component: lazyWithRetry(() => import('app/pages/system/chatEscalation/ChatEscalationPage')),
      pageCode: PAGE_CODES.CHAT_ESCALATION_LADDER,
    },
  ],
};

export default routesConfig;
